import React from 'react';
import PropTypes from 'prop-types';
import './Count.scss';

const Count = ({color = 'green', count = 0, size = 'l', hasPlus = false, className = '', limit = 0}) => {
    const countClass = size === 'l' ? (Number(count) > 999 ? 'big' : 'small') : Number(count) > 99 ? 'big' : 'small';

    const countNumber = hasPlus ? `+${count}` : count;
    return <div
        className={`total_count ${color} ${size} ${countClass} ${className}`}>{limit > 0 ? countNumber > limit ? `+${limit}` : countNumber : countNumber}</div>;
};

export default Count;

Count.propTypes = {
    color: PropTypes.oneOf(['yellow', 'purple', 'green', 'gray', 'blue']),
    count: PropTypes.number,
    size: PropTypes.oneOf(['xxs', 'xs', 'l'])
};
